import { _ as r } from "../internals/export.js";
import { g as t } from "../internals/global.js";
import { g as n } from "../internals/get-built-in.js";
import { f as o } from "../internals/function-uncurry-this.js";
import { f as a } from "../internals/function-call.js";
import { f as i } from "../internals/fails.js";
import { t as e } from "../internals/to-string.js";
import { h as s } from "../internals/has-own-property.js";
import { v as l } from "../internals/validate-arguments-length.js";
import { b as f } from "../internals/base64-map.js";
var m = f.ctoi,
  c = /[^\d+/a-z]/i,
  p = /[\t\n\f\r ]+/g,
  g = /[=]{1,2}$/,
  u = n("atob"),
  h = String.fromCharCode,
  j = o("".charAt),
  b = o("".replace),
  d = o(c.exec),
  v = i(function () {
    return "" !== u(" ");
  }),
  w = !i(function () {
    u("a");
  }),
  x = !v && !w && !i(function () {
    u();
  }),
  y = !v && !w && 1 !== u.length;
r({
  global: !0,
  bind: !0,
  enumerable: !0,
  forced: v || w || x || y
}, {
  atob: function atob(r) {
    if (l(arguments.length, 1), x || y) return a(u, t, r);
    var o,
      i,
      f = b(e(r), p, ""),
      v = "",
      w = 0,
      C = 0;
    if (f.length % 4 == 0 && (f = b(f, g, "")), f.length % 4 == 1 || d(c, f)) throw new (n("DOMException"))("The string is not correctly encoded", "InvalidCharacterError");
    for (; o = j(f, w++);) s(m, o) && (i = C % 4 ? 64 * i + m[o] : m[o], C++ % 4 && (v += h(255 & i >> (-2 * C & 6))));
    return v;
  }
});